var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imageBackground",staticClass:"message-image message-image-admin"},[_c('img',{attrs:{"src":_vm.message.file.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }